/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */
import '@material/toolbar/mdc-toolbar.scss';

/**
 * Create the component.
 */
export default class ToolbarRow extends Component {
  render({
           'class': className,
           children,
           ...props
         }, state, context) {
    const classes = classnames('mdc-toolbar__row', className);
    return (
      <div class={classes} {...props}>{children}</div>
    );
  }
}



// WEBPACK FOOTER //
// ../q-mdc/elements/material-toolbar-row/index.js